package com.example.mystybag.appCore.views.pages

import androidx.compose.runtime.Composable
import com.example.mystybag.appCore.logic.pages.FavoritesPageViewModel

@Composable
fun FavoritesPageWebView(viewModel: FavoritesPageViewModel) {
    FavoritesPageView(viewModel = viewModel)
}
